<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15tvDQe/tc-custom/9781466863149.jpg?1735615864944" alt="This image is the cover for the book Sins of the Mother, St. Martin's True Crime Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sins of the Mother, St. Martin's True Crime Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>The true crime account of the infamous South Carolina mother who intentionally drowned her two sons—includes in-depth interviews with sources close to her.</b><br/><br/>On October 25, 1994, a hysterical Susan Smith told police a tale that would strike terror in the hearts of mothers everywhere: An unidentified gunman had sped off with her two little boys, leaving her screaming on the side of the road.<br/><br/>For more than a week, the people in the tiny town of Union, South Carolina, rallied around the young mother. They combed the woods and neighborhood parks for the missing children and prayed for their safe return, while FBI teams launched a massive manhunt.<br/><br/>No one ever suspected that the pretty twenty-three-year-old who tearfully pleaded for her children in front of millions of TV viewers could be capable of such a heartless act . . . until she led police to the watery graves of her young sons.<br/><br/>Join the shaken community’s journey of grappling with their sorrow, anger, and confusion. <i>Sins of the Mother </i>is more than a crime story; it’s an exploration of human frailty and the dark side of maternal love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maria Eftimiades
      </h2>
      
      <p class="authorDescription body article"><P>Maria Eftimiades is the author of <I>Sins of the Mother.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?605e1dfc